<template>

    <section>

        <!-- ここから -->
        <div class="us_component form_admin-container">

            <swiper
                class="switch-btn-wrap"
                :slides-per-view="2.5"
                :space-between="0"
                :mousewheel="true"
                :speed="500"
                :breakpoints='{
                    "768": {
                        "slidesPerView": 3.5,
                    },
                    "1024": {
                        "slidesPerView": 5.5,
                    },
                } '
            >
                <swiper-slide class="switch-btn _current">
                    <label for="contents0"><span>ユーザー情報</span></label>
                </swiper-slide>
                <swiper-slide class="switch-btn">
                    <label for="contents1"><span>通知設定</span></label>
                </swiper-slide>
                <swiper-slide class="switch-btn">
                    <label for="contents2"><span>パスワード設定</span></label>
                </swiper-slide>
                <!-- <swiper-slide class="switch-btn">
                    <label for="contents3"><span>パスワード設定</span></label>
                </swiper-slide> -->
                <!-- <swiper-slide class="switch-btn">
                    <label for="contents4"><span>通知設定</span></label>
                </swiper-slide> -->
                <!-- <swiper-slide class="switch-btn">
                    <label for="contents5"><span>パスワード設定</span></label>
                </swiper-slide>
                <swiper-slide class="switch-btn">
                    <label for="contents6"><span>ユーザー情報</span></label>
                </swiper-slide>
                <swiper-slide class="switch-btn">
                    <label for="contents7"><span>通知設定</span></label>
                </swiper-slide>
                <swiper-slide class="switch-btn">
                    <label for="contents8"><span>パスワード設定</span></label>
                </swiper-slide> -->
            </swiper>

            <!-- ユーザー情報 :::::::::::::::::::::::::::::::::::::::-->
            <input type="radio" name="switch-content1" id="contents0" checked>
            <div class="switch-contents">
                <div class="md_common-bl _padding-add">
                    <div class="inner">

                        <!-- UserInfoWrap -->
                        <div class="user-info-wrap">

                            <!-- LeftColumn -->
                            <div class="block">

                                <!--UserAvatar-->
                                <div class="avatar-image-wrap">
                                    <input type="file" id="user-avatar" accept="image/*" data-preview="_user-avatar">
                                    <label for="user-avatar"></label>
                                    <img class="preview _user-avatar" src="/img/blank.png">
                                    <div class="no-image">
                                        <SvgIconImagePlace />
                                    </div>
                                </div>
                                <div class="avatar-image-control">
                                    <!-- Delete -->
                                    <button class="btn_svg-icon">
                                        <SvgIconDelete />
                                    </button>
                                    <!-- Reload -->
                                    <label for="user-avatar" class="btn_svg-icon">
                                        <SvgIconReload />
                                    </label>
                                </div>

                            </div><!-- /LeftColumn -->

                            <!-- RightColumn -->
                            <div class="block">

                                <!-- 名前 -->
                                <div class="item form_text">
                                    <div class="input-row">
                                        <input type="text" maxlength="250" id="user-name">
                                    </div>
                                    <label for="user-name"><span>名前</span></label>
                                </div>
                                <!-- メールアドレス -->
                                <div class="item form_text">
                                    <div class="input-row">
                                        <input type="email" id="user-email" inputmode="email">
                                    </div>
                                    <label for="user-email"><span>メールアドレス</span></label>
                                </div>
                                <!-- 電話番号 -->
                                <div class="item form_text">
                                    <div class="input-row">
                                        <input type="tel" id="user-tel" inputmode="tel">
                                    </div>
                                    <label for="user-tel"><span>電話番号</span></label>
                                </div>

                            </div><!-- /RightColumn -->

                        </div><!-- /.user-info-wrap -->

                        <!--btn-link-wrap-->
                        <div class="btn_link-wrap">

                            <!--LinkBtn - キャンセル -->
                            <Link class="btn_link _cancel md_icon-text" :href="route('admin.brand.dm.list')">
                                <div class="inner">
                                    <span><div class="icon"><SvgIconCancel /></div>キャンセル</span>
                                </div>
                            </Link>

                            <!--LinkBtn - 決定アイコン -->
                            <Link class="btn_link md_icon-text _white" :href="route('admin.brand.dm.list')">
                                <div class="inner">
                                    <span><div class="icon"><SvgIconCheck /></div>保存</span>
                                </div>
                            </Link>

                        </div><!--/.btn-link-wrap-->

                    </div>
                </div>
            </div><!-- ユーザー情報 -->

            <!-- 通知設定 :::::::::::::::::::::::::::::::::::::::-->
            <input type="radio" name="switch-content1" id="contents1">
            <div class="switch-contents ">
                <div class="md_common-bl _padding-add">
                    <div class="inner">

                        <!-- UserInfoWrap -->
                        <div class="user-info-wrap">

                            <!--::::::::::::::: .input-group :::::::::::::::-->
                            <div class="input-group">

                                <!-- CheckBoxItem -->
                                <div class="item form_checkbox-text">
                                    <input type="checkbox" name="notice-checkbox1" id="notice-checkbox1-1">
                                    <label for="notice-checkbox1-1">
                                        <div class="mark"></div>
                                        <span>メールを受信する</span>
                                    </label>
                                </div>

                                <!-- CheckBoxItem -->
                                <div class="item form_checkbox-text">
                                    <input type="checkbox" name="notice-checkbox1" id="notice-checkbox1-2">
                                    <label for="notice-checkbox1-2">
                                        <div class="mark"></div>
                                        <p>ブラウザ通知を許可する</p>
                                        <p class="md_text-light">このブラウザーに通知を送信する権限をAUMAに付与してください</p>
                                    </label>
                                </div>

                            </div><!-- /.input-group :::::::::::::::-->

                        </div><!-- /.user-info-wrap -->

                        <!--btn-link-wrap-->
                        <div class="btn_link-wrap">

                            <!--LinkBtn - 決定アイコン -->
                            <Link class="btn_link md_icon-text _white" :href="route('admin.brand.dm.list')">
                                <div class="inner">
                                    <span><div class="icon"><SvgIconCheck /></div>保存</span>
                                </div>
                            </Link>

                        </div><!--/.btn-link-wrap-->

                    </div>
                </div>
            </div><!-- 通知設定 -->

            <!-- パスワード設定 (メールアドレス入力画面) :::::::::::::::::::::::::::::::::::::::-->
            <input type="radio" name="switch-content1" id="contents2">
            <div class="switch-contents">
                <div class="md_common-bl _padding-add">
                    <div class="inner">

                        <!-- UserInfoWrap -->
                        <div class="user-info-wrap">

                            <!--::::::::::::::: .input-group :::::::::::::::-->
                            <div class="input-group">

                                <p class="text">ご利用のメールアドレスに再設定用URLの記載されたメールを送信いたします。URLをクリックしてパスワードを再設定してください。</p>

                                <!-- メールアドレス -->
                                <div class="item form_text">
                                    <div class="input-row">
                                        <input type="email" id="password-email" inputmode="email">
                                    </div>
                                    <label for="password-email"><span>メールアドレス</span></label>
                                </div>

                            </div><!-- /.input-group :::::::::::::::-->

                        </div><!-- /.user-info-wrap -->

                        <!--btn-link-wrap-->
                        <div class="btn_link-wrap">

                            <!--LinkBtn - 決定アイコン -->
                            <Link class="btn_link md_icon-text _white" :href="route('admin.brand.dm.list')">
                                <div class="inner">
                                    <span><div class="icon"><SvgIconSend /></div>送信</span>
                                </div>
                            </Link>

                        </div><!--/.btn-link-wrap-->

                    </div>
                </div>
            </div><!-- パスワード設定 (メールアドレス入力画面) -->

            <!-- パスワード設定 (再設定画面) :::::::::::::::::::::::::::::::::::::::-->
            <input type="radio" name="switch-content1" id="contents3">
            <div class="switch-contents">
                <div class="md_common-bl _padding-add">
                    <div class="inner">

                        <!-- UserInfoWrap -->
                        <div class="user-info-wrap">

                            <!--::::::::::::::: .input-group :::::::::::::::-->
                            <div class="input-group">

                                <!-- 現在のパスワード -->
                                <div class="item form_text _password">
                                    <div class="input-row">
                                        <input type="password" id="current-password">
                                        <button type="button" id="passview-current" class="passview js-toggle-on"><span></span></button>
                                    </div>
                                    <label for="current-password"><span>現在のパスワード</span></label>
                                </div>

                                <!-- 新しいパスワード -->
                                <div class="item form_text _password">
                                    <div class="input-row">
                                        <input type="password" id="new-password">
                                        <button type="button" id="passview-new" class="passview js-toggle-on"><span></span></button>
                                    </div>
                                    <label for="new-password"><span>新しいパスワード</span></label>
                                </div>

                            </div><!-- /.input-group :::::::::::::::-->

                        </div><!-- /.user-info-wrap -->

                        <!--btn-link-wrap-->
                        <div class="btn_link-wrap">

                            <!--LinkBtn - 決定アイコン -->
                            <Link class="btn_link md_icon-text _white" :href="route('admin.brand.dm.list')">
                                <div class="inner">
                                    <span><div class="icon"><SvgIconCheck /></div>保存</span>
                                </div>
                            </Link>

                        </div><!--/.btn-link-wrap-->

                    </div>
                </div>
            </div><!-- パスワード設定 (メールアドレス入力画面) -->

        </div>
        <!-- ここまで -->

    </section>

</template>


<script>
    import { Link } from '@inertiajs/inertia-vue3'

    //Svg
    import SvgIconEdit from '@/components/EndUser/svg/SvgIconEdit'
    import SvgIconAdd from '@/components/EndUser/svg/SvgIconAdd'
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'
    import SvgIconCancel from '@/components/EndUser/svg/SvgIconCancel'
    import SvgIconBack from '@/components/EndUser/svg/SvgIconBack'
    import SvgIconDelete from '@/components/EndUser/svg/SvgIconDelete'
    import SvgIconImagePlace from '@/components/EndUser/svg/SvgIconImagePlace'
    import SvgIconMail from '@/components/EndUser/svg/SvgIconMail'
    import SvgIconChat from '@/components/EndUser/svg/SvgIconChat'
    import SvgIconSearch from '@/components/EndUser/svg/SvgIconSearch'
    import SvgIconSend from '@/components/EndUser/svg/SvgIconSend'
    import SvgIconReload from '@/components/EndUser/svg/SvgIconReload'

    //Swiper.js
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import 'swiper/css';

    //Swiper.js - css
    import "swiper/css/pagination"
    import "swiper/css/navigation"


    export default {
        components: {
            "Link": Link,
            //Swiper
            Swiper,
            SwiperSlide,
            //Svg
            SvgIconEdit,
            SvgIconCheck,
            SvgIconCancel,
            SvgIconBack,
            SvgIconBack,
            SvgIconDelete,
            SvgIconImagePlace,
            SvgIconMail,
            SvgIconChat,
            SvgIconSearch,
            SvgIconSend,
            SvgIconReload,
            SvgIconAdd
        },
        mounted() {

            ////////////////////////////////////////////////
            //  パスワードの一時的な可視化
            ////////////////////////////////////////////////
            window.addEventListener('DOMContentLoaded', function(){
                // (1)パスワード入力欄とボタンのHTMLを取得
                let passviewCurrent = document.getElementById("passview-current");
                let currentPassword = document.getElementById("current-password");
                // (2)ボタンのイベントリスナーを設定
                passviewCurrent.addEventListener("click", (e)=>{
                    // (3)ボタンの通常の動作をキャンセル（フォーム送信をキャンセル）
                    e.preventDefault();
                // (4)パスワード入力欄のtype属性を確認
                if( currentPassword.type === 'password' ) {
                    // (5)パスワードを表示する
                    currentPassword.type = 'text';
                } else {
                    // (6)パスワードを非表示にする
                    currentPassword.type = 'password';
                }
                });
            });
            window.addEventListener('DOMContentLoaded', function(){
                // (1)パスワード入力欄とボタンのHTMLを取得
                let passviewNew = document.getElementById("passview-new");
                let newPassword = document.getElementById("new-password");
                // (2)ボタンのイベントリスナーを設定
                passviewNew.addEventListener("click", (e)=>{
                    // (3)ボタンの通常の動作をキャンセル（フォーム送信をキャンセル）
                    e.preventDefault();
                // (4)パスワード入力欄のtype属性を確認
                if( newPassword.type === 'password' ) {
                    // (5)パスワードを表示する
                    newPassword.type = 'text';
                } else {
                    // (6)パスワードを非表示にする
                    newPassword.type = 'password';
                }
                });
            });

            ////////////////////////////////////////////////
            //  ブランド- 個人設定 - ユーザー情報
            //  ボタンのカレント表示切り替え
            ////////////////////////////////////////////////
            $('.switch-btn').on('click', function () {
                $(this).addClass('_current');
                $(this).siblings().removeClass('_current');
            });

            ////////////////////////////////////////////////
            //  ユーザー画像のプレビュー
            ////////////////////////////////////////////////
            $('[data-preview]').on('change', function (e) {
                var target = $(e.target);
                var targetPreviewSelector = target.attr('data-preview');
                var reader = new FileReader();
                if (!targetPreviewSelector) {
                    targetPreviewSelector = target.parents('[data-preview]').attr('data-preview');
                }
                reader.onload = function (e) {
                    $('.preview.' + targetPreviewSelector).attr('src', e.target.result);
                }
                reader.readAsDataURL(e.target.files[0]);
            });

        }
    }
</script>
